/** @module Auth0NotificationPageHelper */
/* eslint-disable import/extensions */
import { Auth0PageBase } from './auth0-page-template.mst.mjs';
import NotificationHtml from '../../../public/notificationPage.html.mst';
import Auth0UtilsBrowser from '../../utils/auth0-utils-browser.mjs';
import Auth0Localizer from '../../utils/auth0-localization-helper.mjs';
import Auth0Cdn from '../utils/auth0-cdn-resource-resolver.mst.mjs';

const TITLE_DIV_ID = 'notification-message-title';
const FOOTER_DIV_ID = 'notification-message-footer';
const ERROR_DIV_ID = 'error-message-body';
const INFO_DIV_ID = 'info-message-body';
const TEMPLATE_DIV_ID = '-message-body';

class Auth0NotificationPageHelper extends Auth0PageBase {
  constructor(options) {
    super(options);
    this._notificationText = options.notificationText;
    this._notificationTextReplacementVars = options.notificationTextReplacementVars;

    this._notificationTitle = options.notificationTitle;
    this._notificationTitleReplacementVars = options.notificationTitleReplacementVars;

    this._showNotificationFooter = options.showNotificationFooter === undefined ? true : options.showNotificationFooter;
    this._notificationFooter = options.notificationFooter;
    this._notificationFooterReplacementVars = options.notificationFooterReplacementVars;

    this._notificationType = options.notificationType;

    this._notificationIconUrl = options.notificationCustomIconUrl;

    if (!this._notificationIconUrl) {
      this._notificationIconUrl = this._isErrorNotification
        ? Auth0Cdn.AUTH0_NOTIFICATION_ERROR_ICON_URL
        : Auth0Cdn.AUTH0_NOTIFICATION_INFO_ICON_URL;
    }
  }

  get notificationType() {
    return this._notificationType || Auth0NotificationPageHelper.NOTIFICATION_TYPE_INFO;
  }

  static get NOTIFICATION_TYPE_ERROR() { return 'error'; }

  static get NOTIFICATION_TYPE_INFO() { return 'info'; }

  async _onLoad() {
    await super._onLoad();
    // called when render of underlying template is complete
    this.toolbarVisible = false;
    await this.setBody(NotificationHtml);
  }

  get _isErrorNotification() {
    return this.notificationType === Auth0NotificationPageHelper.NOTIFICATION_TYPE_ERROR;
  }

  get _isInfoNotification() {
    return this.notificationType === Auth0NotificationPageHelper.NOTIFICATION_TYPE_INFO;
  }

  _displayLocalizedNotification = (msgKey, msgType) => {
    console.log(`_displayLocalizedNotification=>${msgKey}`);
    Auth0Localizer.setElementLocalizedText({ id: `${msgType}${TEMPLATE_DIV_ID}`, resourceIdOverride: msgKey }, this._notificationTextReplacementVars);
    const msgContainer = document.getElementById(`${msgType}${TEMPLATE_DIV_ID}`);
    msgContainer.style.display = 'block';
  };

  _displayNotification = (msgText) => {
    const notifyEle = this._isErrorNotification
      ? document.getElementById(ERROR_DIV_ID)
      : document.getElementById(INFO_DIV_ID);
    notifyEle.innerText = msgText;
    notifyEle.style.display = 'block';
  };

  _setNotificationIcon = () => {
    const iconSize = '100%';
    const svgIcon = Auth0UtilsBrowser.createSVG(this._notificationIconUrl, iconSize);

    document.getElementById('notification-icon-container').appendChild(svgIcon);
  };

  _setTitle = () => {
    if (this._isErrorNotification && !this._notificationTitle) {
      Auth0Localizer.setElementLocalizedText({ id: TITLE_DIV_ID, resourceIdOverride: 'error-encountered-a-problem' });
      document.getElementById(TITLE_DIV_ID).style.display = 'block';
    }
    if (!this._notificationTitle) return;

    Auth0Localizer.setElementLocalizedText({ id: TITLE_DIV_ID, resourceIdOverride: this._notificationTitle }, this._notificationTitleReplacementVars);
    document.getElementById(TITLE_DIV_ID).style.display = 'block';
  };

  _setFooter = () => {
    if (!this._showNotificationFooter) return;
    if (this._isErrorNotification && !this._notificationFooter) {
      Auth0Localizer.setElementLocalizedText({ id: FOOTER_DIV_ID, resourceIdOverride: 'error-footer' }, { supportEmail: this._whiteLabelHelper.appLoginSupportEmail, supportPhoneNumber: this._whiteLabelHelper.appLoginSupportPhoneNumber });
      document.getElementById(FOOTER_DIV_ID).style.display = 'block';
    }
    if (!this._notificationFooter) return;

    Auth0Localizer.setElementLocalizedText({ id: FOOTER_DIV_ID, resourceIdOverride: this._notificationFooter }, this._notificationFooterReplacementVars);
    document.getElementById(FOOTER_DIV_ID).style.display = 'block';
  };

  _initNotificationHtml = () => {
    this._setNotificationIcon();

    const localizationKey = Auth0Localizer.resourceKeyFromMessage(this._notificationText);
    if (localizationKey) {
      this._displayLocalizedNotification(localizationKey, this.notificationType);
    } else {
      this._displayNotification(this._notificationText);
    }

    this._setTitle();
    this._setFooter();
  };

  /**
   * @function
   * @async
   */
  async _startUi() {
    await super._startUi();
    this._initNotificationHtml();
    this._showPage();
  }
}

export default Auth0NotificationPageHelper;
